import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Demo environment (`admin.demo.wisesys.info`)
 */
export const demoServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.demo.wisesys.info',
    auroraApiServer: 'https://demo.aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://69g552rju8.execute-api.us-east-1.amazonaws.com/demo',
    socketServer: 'wss://demo.socket.wisesys.info',
    auroraServer: 'https://demo-api.aurora-v2.wisesys.info',
    environment: ServerEnvironment.DEMO,
    CIEnv: ServerCIEnvironment.DEMO,
    vehicleProfile:
        'https://hgfk0t7kh3.execute-api.us-east-1.amazonaws.com/demo',
    routePathGeometryServer:
        'https://wnfltdovrb.execute-api.us-east-1.amazonaws.com/demo',
    configurableWorkflowServer:
        'https://zq3uoax4v9.execute-api.us-east-1.amazonaws.com/Prod',
    equipment: 'https://services-demo.us.wisesys.info',
    driverCostServer:
        'https://ydqfur71s3.execute-api.us-east-1.amazonaws.com/demo',
    bannerService: 'https://x9xa461k9d.execute-api.us-east-1.amazonaws.com/demo'
};
